import type { DispensaryTransactionFromBankCore } from '@gcv/shared';
import { useQuery } from '@tanstack/react-query';

import { BanksApi } from 'api';
import { CORE_TRANSACTIONS_BY_ID_KEY } from 'tanstack-hooks/keys';
import { useUser } from 'tanstack-hooks/user';

export function useCoreTransactionsById(ids: string[]) {
  const { userBankId } = useUser();
  const banksApi = new BanksApi();

  const { data, isLoading: isLoadingCoreTransactions } = useQuery<DispensaryTransactionFromBankCore[]>({
    enabled: ids.length > 0 && !!userBankId,
    queryKey: [CORE_TRANSACTIONS_BY_ID_KEY, userBankId, ids],
    queryFn: async () => {
      return await banksApi.getCoreTransactionsById(userBankId, ids);
    },
    meta: {
      snackbarErrorMessage:
        'There was an issue loading core transaction details. Please try again, or contact support if the problem persists.'
    }
  });

  return { coreTransactions: data, isLoadingCoreTransactions };
}
